import { render, staticRenderFns } from "./UsefulReserveTable.vue?vue&type=template&id=190e9f7e&scoped=true&"
import script from "./UsefulReserveTable.vue?vue&type=script&lang=js&"
export * from "./UsefulReserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e9f7e",
  null
  
)

export default component.exports